export const SOCIAL_LINK = {
  twitter: 'https://twitter.com/qemotionapp',
  facebook: 'https://www.facebook.com/qemotionproject/',
  youtube: 'https://www.youtube.com/channel/UCM2R6zrxaF0gnpS87R41vDw',
  linkedin: 'https://www.linkedin.com/company/qemotion/',
};
